import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "./chatAppointmentSuccessPopup.module.css";
import doctor from "../../../images/questionnaire_doctor.png";
import { IPopupWithoutProps } from "../../../types/types";

function ChatAppointmentSuccessPopup({ onClose }: IPopupWithoutProps) {
  return (
    <article className={popupStyles.popup}>
      <h2 className={popupStyles.popup__title}>   {t("CHAT_APPOINTMENT_SUCCESS_TITLE")}</h2>
      <img
        src={doctor}
        alt={t("IMAGE_ALT_VENCHY_DOCTOR")}
        className={popupStyles.popup__img}
      />
      <p className={popupStyles.popup__text}>
        {t("CHAT_APPOINTMENT_SUCCESS_TEXT")}      </p>
      <button
        className={`button hover ${popupStyles.popup__nextBtn}`}
        onClick={onClose}
      >
        {t("SUCCESS_CONFIRM_BUTTON")}
      </button>
    </article>
  );
}

export default ChatAppointmentSuccessPopup;
